<div class="animation-component-wrapper limit-width-on-desktop-float" *ngIf="show">
  <div class="animation-wrapper">
    <lottie-player autoplay mode="normal" loop src="assets/lottie-animations/fetching-policy.json"></lottie-player>
  </div>
  <div class="content-wrapper">
    <h2 class="h2-bold">Final check underway</h2>
    <p>Please be patient as we make sure everything is 100%.</p>
  </div>
</div>
